import { render } from "./PriceListDraftPanel.vue?vue&type=template&id=1977c0f6&scoped=true"
import script from "./PriceListDraftPanel.vue?vue&type=script&lang=js"
export * from "./PriceListDraftPanel.vue?vue&type=script&lang=js"

import "./PriceListDraftPanel.vue?vue&type=style&index=0&id=1977c0f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1977c0f6"]])

export default __exports__